import { Store } from 'redux';
import { selectPageModelNetwork } from 'store/pageModel';
import {
	instoreActions,
	instoreServiceActions,
	selectCategoriesNetwork,
	selectServiceNetwork,
	selectStoresNetwork,
} from 'containers/instore';
import { ErrorTypes, LoadDataReject } from 'types/load-data-reject-reason';
import { MockStoreLinks } from '../../__mocks__';
import { getPath } from '../../selectors';

const { fetchStoresRequest, fetchCategoriesRequest, setSelectedStoreCode } = instoreActions;
const { fetchServicesRequest } = instoreServiceActions;

export const InstorePageLoadData = (store: Store) =>
	new Promise<void>((resolve, reject: LoadDataReject) => {
		const pageModelNetwork = selectPageModelNetwork(store.getState());
		if (pageModelNetwork.isFetched && pageModelNetwork.isFailed) {
			return reject({ type: ErrorTypes.PAGE_MODEL, message: 'No page model data' });
		}

		//TODO в будущем код магазина будет из модели браться
		const pathname = getPath(store.getState());
		const storeName = pathname.split('/').filter(part => !!part)[2] || null;
		const storeCodeFromUrl = storeName
			? MockStoreLinks.find(({ link }) => link === `${storeName}`)?.code || null
			: null;

		store.dispatch(setSelectedStoreCode({ storeCode: storeCodeFromUrl }));

		store.dispatch(fetchStoresRequest());
		store.dispatch(fetchCategoriesRequest());

		// запускаем фетч услуг, если находимся на странице конкретной категории с выбранным магазином
		const isCategoryPage = !pathname.includes('/uslugi-v-magazinah');
		const isCategoryWithStorePage = isCategoryPage && storeCodeFromUrl;

		if (isCategoryWithStorePage) {
			store.dispatch(fetchServicesRequest());
		}

		const unsub = store.subscribe(() => {
			const categoriesNetwork = selectCategoriesNetwork(store.getState());
			const storeNetwork = selectStoresNetwork(store.getState());
			const servicesNetwork = selectServiceNetwork(store.getState());

			const isMainDataFetched = categoriesNetwork.isFetched && storeNetwork.isFetched;

			const isAllDataFetched = isCategoryWithStorePage
				? isMainDataFetched && servicesNetwork.isFetched
				: isMainDataFetched;

			// если страница категории, ждем пока все 3 запроса сфетчатся
			// если разводящая страница, то ждем только список категорий и магазинов
			if (isAllDataFetched) {
				unsub();

				if (categoriesNetwork.isFailed) {
					return reject({
						type: ErrorTypes.DATA,
						message: 'Instore categories data was not fetched',
					});
				}

				if (storeNetwork.isFailed) {
					return reject({
						type: ErrorTypes.DATA,
						message: 'Stores data was not fetched',
					});
				}

				if (isCategoryWithStorePage && servicesNetwork.isFailed) {
					return reject({
						type: ErrorTypes.DATA,
						message: 'Services data was not fetched',
					});
				}

				return resolve();
			}
		});
	});
